import { render, staticRenderFns } from "./RemoteControlBlocker.vue?vue&type=template&id=1c695164&scoped=true&lang=pug&"
import script from "./RemoteControlBlocker.vue?vue&type=script&lang=js&"
export * from "./RemoteControlBlocker.vue?vue&type=script&lang=js&"
import style0 from "./RemoteControlBlocker.vue?vue&type=style&index=0&id=1c695164&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c695164",
  null
  
)

export default component.exports